<!--台风-->
<template>
  <div class="thphoon">
        <iframe src="http://typhoon.zjwater.gov.cn/default.aspx" :width="width+'px'" :height="height+'px'" ></iframe>
  </div>
</template>
<script>
import $ from "jquery";
let moment = require("moment");
export default {
  name: "thphoon",
  data() {
    return {
      height:0,
      width:0,
    };
  },
 
  methods: {
  },
  mounted() {
    // $(".thphoon").height(window.innerHeight-140-35-20);
    $(".thphoon").height(window.innerHeight);
    var w=$(".thphoon").width();
    this.height=$(".thphoon").height()-2;
    this.width=w;
    // this.getWeatherInfo();
  }
};
</script>
<style scoped lang='less'>
 .thphoon{
   
   width:100%;
   margin: 2px;
 }
</style>
 


// WEBPACK FOOTER //
// src/components/mobile/typhoon.vue